import { TableBox } from '../TableBox/TableBox'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { Server } from '../../../../../api/Server'
import { ScoopButton, ScoopText, ScoopRow, ScoopColumn, ScoopGrid } from '../../../../ui'
import { useModal, MODALS } from '../../../../modals'
import styles from './TablesInsight.module.scss'

export const TablesInsight = ({ inboxID, tables, datasetName, getMetadata, readOnly }) => {
    const userID = useSelector((state) => state.auth.userID)
    const workspaceID = useSelector((state) => state.auth.workspaceID)
    const token = useSelector((state) => state.auth.token)
    const [server, setServer] = useState(new Server(workspaceID, userID, token))

    const compareTablesModal = useModal(MODALS.SOURCE.COMPARE_TABLES)

    useEffect(() => {
        setServer(new Server(workspaceID, userID, token))
    }, [workspaceID, userID, token])

    const processInboxTableCompare = (result) => {
        compareTablesModal.show({
            tables,
            datasetName,
            compareResult: result,
        })
    }

    const compareInboxTables = (inboxID) => {
        server.postData(
            {
                action: 'compareReportSeriesTables',
                inboxID: inboxID,
            },
            processInboxTableCompare
        )
    }

    return (
        <ScoopColumn className={styles.container}>
            <ScoopRow className={styles.headerRow}>
                <ScoopText className={styles.tableCountText}>
                    {`${tables?.length} tables found from this datasource`}
                </ScoopText>
                {tables?.length >= 2 && (
                    <ScoopButton variant="grey" onClick={() => compareInboxTables(inboxID)}>
                        Compare Tables
                    </ScoopButton>
                )}
            </ScoopRow>
            <ScoopGrid container gap={10} className={styles.tablesGrid}>
                {tables.map((table) => (
                    <TableBox
                        key={table.reportSeriesTableID}
                        getMetadata={getMetadata}
                        table={table}
                        server={server}
                        readOnly={readOnly}
                    />
                ))}
            </ScoopGrid>
        </ScoopColumn>
    )
}
